import { apiBase } from "../api.config";

// 圖片上傳
export const apiImage = (data, token) =>
  apiBase.post("/api/image", data, token);

// 登入驗證
export const LoginManage = {
  login: data => apiBase.post("/api/manager/auth", data),
  confirm: data => apiBase.post("/api/manager/auth/confirm", data)
};

// 廠商帳號管理
export const Vendor = {
  get: token => apiBase.get("/api/manager/vendor", token),
  create: (data, token) => apiBase.post("/api/manager/vendor", data, token),
  update: (id, data, token) =>
    apiBase.put(`/api/manager/vendor/${id}`, data, token),
  status: (id, account_status, token) =>
    apiBase.patch(`/api/manager/vendor/${id}`, account_status, token)
};

// 會員列表
export const User = {
  get: token => apiBase.get("/api/manager/user", token)
};

// 分類管理
export const Category = {
  // 汽車分類
  style: {
    // 製造商
    brand: {
      get: (id, token) =>
        apiBase.get(`/api/manager/car-brand/${id || ""} `, token),
      create: (name, token) =>
        apiBase.post("/api/manager/car-brand", name, token),
      update: (id, name, token) =>
        apiBase.put(`/api/manager/car-brand/${id}`, name, token),
      del: (id, token) => apiBase.delete(`/api/manager/car-brand/${id}`, token)
    },
    // 型號
    model: {
      get: (id, modelId, token) =>
        apiBase.get(
          `/api/manager/car-brand/${id}/model/${modelId || ""}`,
          token
        ),
      create: (id, name, token) =>
        apiBase.post(`/api/manager/car-brand/${id}/model`, name, token),
      update: (id, modelId, name, token) =>
        apiBase.put(
          `/api/manager/car-brand/${id}/model/${modelId}`,
          name,
          token
        ),
      del: (id, modelId, token) =>
        apiBase.delete(`/api/manager/car-brand/${id}/model/${modelId}`, token)
    },
    // 年份
    year: {
      get: (id, modelId, yearId, token) =>
        apiBase.get(
          `/api/manager/car-brand/${id}/model/${modelId}/year/${yearId || ""}`,
          token
        ), // 沒有yearId 就是取得全部
      create: (id, modelId, data, token) =>
        apiBase.post(
          `/api/manager/car-brand/${id}/model/${modelId}/year`,
          data,
          token
        ),
      update: (id, modelId, yearId, data, token) =>
        apiBase.put(
          `/api/manager/car-brand/${id}/model/${modelId}/year/${yearId}`,
          data,
          token
        ),
      del: (id, modelId, yearId, token) =>
        apiBase.delete(
          `/api/manager/car-brand/${id}/model/${modelId}/year/${yearId}`,
          token
        )
    }
  },
  // 零件分類
  part: {
    get: (id, token) =>
      apiBase.get(`/api/manager/part-category/${id || ""} `, token),
    create: (name, token) =>
      apiBase.post("/api/manager/part-category", name, token),
    update: (id, name, token) =>
      apiBase.put(`/api/manager/part-category/${id}`, name, token),
    del: (id, token) =>
      apiBase.delete(`/api/manager/part-category/${id}`, token)
  },
  part_brand: {
    get: (id, token) =>
      apiBase.get(`/api/manager/part-brand/${id || ""} `, token),
    create: (name, token) =>
      apiBase.post("/api/manager/part-brand", name, token),
    update: (id, name, token) =>
      apiBase.put(`/api/manager/part-brand/${id}`, name, token),
    del: (id, token) => apiBase.delete(`/api/manager/part-brand/${id}`, token)
  }
};

// 購物須知
export const ShoppingNote = {
  get: token => apiBase.get("/api/manager/shopping-note", token),
  update: (data, token) =>
    apiBase.post("/api/manager/shopping-note", data, token)
};

export const SMS = {
  get: token => apiBase.get("/api/manager/sms/point", token)
};
